import { Component } from '@angular/core';
import { UserOverviewComponent } from './user-overview.component';
import { ReusableTabsComponent } from '@nimmsta/ng-commons-lib/reusable-tabs';
import { UserComponent } from './user.component';
import { WorkerComponent } from '../worker/worker.component';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';

@Component({
  selector: 'app-admin-user-overview',
  templateUrl: 'user-overview.component.html',
  imports: [
    ReusableTabsComponent,
    UserComponent,
    WorkerComponent,
    HeaderBarComponent,
  ],
})
export class AdminUserOverviewComponent extends UserOverviewComponent {
  constructor() {
    super();
    this.tabsConfig.storageKey = 'adminUserOverview';
    this.showAdminActions = true;
  }
}
